export const environment = {
  firebase: {
    apiKey: 'AIzaSyCWzD8yz4L24co8n4GnzhXlMAvmDPgwygQ',
    authDomain: 'quicknotes-afb44.firebaseapp.com',
    projectId: 'quicknotes-afb44',
    storageBucket: 'quicknotes-afb44.appspot.com',
    messagingSenderId: '207056778745',
    appId: '1:207056778745:web:7e22c55342d7c3ca10f928',
    measurementId: '${config.measurementId}',
  },
  production: true,
};
